var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_vm._m(0),_c('div',{staticClass:"btn-box"},[_c('button',{staticClass:"home",on:{"click":_vm.Home}},[_vm._v("返回首页")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/success.png")}}),_c('p',[_vm._v("支付成功")])])
}]

export { render, staticRenderFns }